module.exports = "<div class=\"ppa-client-add\"><ppa-client-form on-submit=\"vm.submitClient\" client=\"vm.client\"></ppa-client-form></div>";